import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import FallbackImage from "../FallbackImage/FallbackImage";
import PropTypes from "prop-types";
import styles from "./TopCreators.module.css";

const TopCreators = ({
  className = "",
  number,
  logo,
  name,
  totalSales,
  creatorId,
  descriptor,
  change,
}) => {

  const navigate = useNavigate();

  const handleCreatorClick = () => {
    navigate(`/creator/${descriptor}`);
  };

  const changeValue = parseFloat(change.replace('%', '').replace(',', '.'));
  const changeClass = changeValue > 0 ? styles.positiveChange : styles.negativeChange;

  const line = "/line.svg";

  return (
    <Box className={[styles.topCreators, className].join(" ")} onClick={handleCreatorClick}>
      <Box className={styles.creatorInfo}>
        <Typography className={`${styles.number} ${styles.boldText}`}>
          {number}
        </Typography>
        <FallbackImage
          className={styles.sharksLogoFromSanJose}
          loading="lazy"
          alt={name}
          src={logo}
          type={'user'}
        />
        <Box className={styles.creatorDetails}>
          <Typography className={`${styles.name} ${styles.boldText}`}>
            {name}
          </Typography>
          <Box className={styles.volume}>
            <Typography className={styles.price}>{totalSales}</Typography>
          </Box>
        </Box>
        {/* <Box className={`${styles.change} ${changeClass}`}>{change}</Box> */}
      </Box>
      <img className={styles.lineIcon} alt="" src={line} />
    </Box>
  );
};

TopCreators.propTypes = {
  className: PropTypes.string,
  number: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  totalSales: PropTypes.string.isRequired,
  creatorId: PropTypes.string.isRequired,
  descriptor: PropTypes.string.isRequired,
  change: PropTypes.string.isRequired,
};

export default TopCreators;